export default "__VITE_ASSET__4tRX$tvB__"